import { Navigate } from "react-router-dom"

import { AFTER_FOOTER } from "utils/constants"
import { Footer, CreatePortalAfterComponent, Layout } from "components"
import { buildHashIdsQuery } from "utils/helpers"
import { useQueryContext } from "utils/hooks"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { ViewMode } from "utils/interfaces"
import { BookingProvider } from "modules/Booking/BookingContext"
import { useGetDepositConfigurations } from "modules/Booking/common/utils"
import { useSearchParams } from "utils/customHooks"

export function BookingWrapper() {
    const searchParams = useSearchParams()
    const mode = searchParams.get("from_mode") as ViewMode
    const hashId = searchParams.get("hash_id") as string
    const query = buildHashIdsQuery({
        hashIds: [hashId],
        includeLegalInfo: true,
        resultsKey: undefined,
        source: {
            mode,
            true_mode: "booking",
            search_terms: {},
        },
    })

    const [{ response }] = useQueryContext(query)
    const [{ isVerified }] = useClientContext()

    const { data: deposits } = useGetDepositConfigurations(isVerified)

    if (!hashId) {
        return <Navigate to="/survey/psy" replace />
    }

    return (
        <Layout isLoading={!response}>
            {response && (
                <CreatePortalAfterComponent idPortalName={AFTER_FOOTER}>
                    <BookingProvider psy={response.profiles[0]} deposits={deposits} />
                    <Footer />
                </CreatePortalAfterComponent>
            )}
        </Layout>
    )
}
